import axios from "@/plugins/axios";

let url = "/api/v1/banners";

export default {
    get(data){
        return axios.get(`${url}/${data.code}`).then(result => result.data);
    }
}
